import { render } from "./a-task-timeblocks.vue?vue&type=template&id=37c877b0"
import script from "./a-task-timeblocks.vue?vue&type=script&lang=js"
export * from "./a-task-timeblocks.vue?vue&type=script&lang=js"

import "./a-task-timeblocks.vue?vue&type=style&index=0&id=37c877b0&lang=sass"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__